import { render, staticRenderFns } from "./EmailConfirmationDialog.vue?vue&type=template&id=378368c2&scoped=true&"
import script from "./EmailConfirmationDialog.vue?vue&type=script&lang=ts&"
export * from "./EmailConfirmationDialog.vue?vue&type=script&lang=ts&"
import style0 from "./EmailConfirmationDialog.vue?vue&type=style&index=0&id=378368c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378368c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog})
